import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale/index';

import defaultStyles from './ExpandableText.jss';

const HTML = Platform.select({
    default: require('react-native-render-html').RenderHTML
    // web: ({ source, style }) => {
    //     return <div style={style} dangerouslySetInnerHTML={{ __html: source.html }} />;
    // }
});

const systemFonts = ['TeleGroteskNext-Regular'];

const ExpandableText = ({
    text,
    expandTitle,
    maxCharacters,
    style,
    expanded,
    condenseTextTitle
}) => {
    const [isExpanded, setIsExpanded] = useState(expanded);
    const [textSection, setTextSection] = useState('');
    const { width: contentWidth } = useWindowDimensions();

    useEffect(() => {
        let content = text;
        if (text?.length > maxCharacters) {
            content = `${text.substring(
                0,
                Math.min(maxCharacters, text.length)
            )}... <a class="expandTitle" href="#more">${expandTitle}</a>`;
        }

        setTextSection(`<div class="text"  >${content}</div>`);
    }, []);

    const getCondensedContent = useCallback(
        (fullText) => {
            let content = fullText;
            if (fullText?.length > maxCharacters) {
                content = `${fullText.substring(
                    0,
                    Math.min(maxCharacters, fullText.length)
                )}... <a class="expandTitle" href="#more">${expandTitle}</a>`;
            }
            return content;
        },
        [maxCharacters, expandTitle]
    );

    const getUpdatedContent = useCallback(
        (fullText) => {
            let content = fullText;
            if (!isExpanded) {
                content = `${fullText} <a class="condenseTextTitle" href="#less">${condenseTextTitle}</a>`;
            } else {
                content = getCondensedContent(fullText);
            }
            setTextSection(`<div class="text">${content}</div>`);
        },
        [isExpanded, condenseTextTitle, getCondensedContent]
    );

    const classesStyles = useMemo(
        () => ({
            ...defaultStyles,
            text: {
                ...defaultStyles.text,
                ...style
            }
        }),
        [style]
    );
    const renderersProps = useMemo(
        () => ({
            a: {
                onPress: () => {
                    setIsExpanded(!isExpanded);
                    getUpdatedContent(text);
                }
            }
        }),
        [isExpanded, getUpdatedContent, text]
    );
    return (
        <HTML
            style={style}
            classesStyles={classesStyles}
            systemFonts={systemFonts}
            renderersProps={renderersProps}
            source={{ html: textSection }}
            contentWidth={contentWidth}
        />
    );
};

ExpandableText.defaultProps = {
    expandTitle: t('COMMON.MORE'),
    condenseTextTitle: t('COMMON.LESS'),
    maxCharacters: 200,
    style: {},
    expanded: false
};

ExpandableText.propTypes = {
    text: PropTypes.string.isRequired,
    expandTitle: PropTypes.string,
    condenseTextTitle: PropTypes.string,
    maxCharacters: PropTypes.number,
    style: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
    expanded: PropTypes.bool
};

export default ExpandableText;
